import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from "recharts";

export default function BarChartView({ columns = [], rows = [] }) {
  const labelKey = columns[0]?.key;
  const labelName = columns[0]?.label || labelKey;
  const metricColumns = columns.slice(1).map((c) => ({ key: c.key, label: c.label || c.key }));

  const data = useMemo(() => {
    return rows.map((row) => ({
      label: row[labelKey],
      ...metricColumns.reduce((acc, { key }) => ({ ...acc, [key]: row[key] ?? 0 }), {}),
    }));
  }, [rows, labelKey, metricColumns]);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 80 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="label" angle={45} textAnchor="start" interval={0} height={80} />
        <YAxis />
        <Tooltip />
        <Legend />
        {metricColumns.map(({ key, label }, idx) => (
          <Bar key={key} dataKey={key} name={label} fill={["#0f6936", "#2e9245", "#82ca9d", "#8884d8"][idx % 4]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
